export enum NetworkActionEnum {
  Upload,
  Download,
  Delete,
  AuthenticityRecourseBookingError,
  Unknown,
}
